var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2799_51238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9483 66.3979H65.7608V25.9297C65.7608 24.7971 64.8426 23.8789 63.7101 23.8789H55.507C54.3745 23.8789 53.4563 24.7971 53.4563 25.9297V66.3979H49.3548V39.6013C49.3548 38.4688 48.4366 37.5506 47.304 37.5506H39.101C37.9685 37.5506 37.0503 38.4688 37.0503 39.6013V66.3979H32.9488V47.1208C32.9488 45.9882 32.0306 45.07 30.898 45.07H22.695C21.5624 45.07 20.6442 45.9882 20.6442 47.1208V66.3979H16.5427V52.0426C16.5427 50.91 15.6246 49.9918 14.492 49.9918H6.28898C5.15641 49.9918 4.23822 50.91 4.23822 52.0426V66.3979H2.05075C0.91819 66.3979 0 67.316 0 68.4486C0 69.5812 0.91819 70.4994 2.05075 70.4994H67.9483C69.0808 70.4994 69.999 69.5812 69.999 68.4486C69.999 67.316 69.0808 66.3979 67.9483 66.3979Z",
    fill: "#009999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05075 44.5648C14.8499 44.5648 28.7297 39.9681 41.1335 31.6214C50.8479 25.0843 58.9458 16.7332 63.9758 8.182L65.9675 15.6149C66.2131 16.5312 67.3985 17.3228 68.4792 17.0649C69.5808 16.8021 70.2223 15.6473 69.9292 14.5533L66.571 2.02044C66.2777 0.926572 65.1538 0.277167 64.0594 0.570424L51.5265 3.9286C50.4325 4.22172 49.7834 5.34622 50.0765 6.44023C50.3698 7.53423 51.4937 8.18364 52.5881 7.89024L60.662 5.72684C55.9692 13.8815 48.2135 21.9133 38.8436 28.2185C27.1095 36.1148 14.0429 40.4633 2.05075 40.4633C0.91819 40.4633 0 41.3815 0 42.5141C0 43.6466 0.91819 44.5648 2.05075 44.5648Z",
    fill: "#009999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2799_51238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.613dcd934aac3d975a51260af6825f98.svg";
export { ForwardRef as ReactComponent };